<template><section><template>
<h3>Popover</h3>
<div class="bs-docs-section" id="Popover">
<div class="bs-example">
  <n3-popover effect="fade" :header="true" title="Title" placement="top">
    <div slot="content">
        Popover on top
    </div>
    <n3-button>Popover on top</n3-button>
  </n3-popover>
  <n3-popover effect="fade" :header="true" title="Title" placement="left">
      <div slot="content">
        Popover on left
    </div>
    <n3-button>Popover on left</n3-button>
  </n3-popover>
  <n3-popover effect="fade" :header="true" title="Title" placement="right">
      <div slot="content">
        Popover on right
    </div>
    <n3-button>Popover on right</n3-button>
  </n3-popover>
  <n3-popover effect="fade" placement="bottom" :header="true" title="Title">
      <div slot="content">
        Popover on bottom
    </div>
    <n3-button>Popover on bottom</n3-button>
  </n3-popover>
  <hr>
  <h4>No title</h4>
  <n3-popover effect="fade" :header="false" title="Title" placement="top">
      <div slot="content">
        Popover on top
      </div>
      <n3-button>Popover on top</n3-button>
  </n3-popover>
  <n3-popover effect="fade" :header="false" title="Title" placement="left">
    <div slot="content">
        Popover on left
    </div>
    <n3-button>Popover on left</n3-button>
  </n3-popover>
  <n3-popover effect="fade" :header="false" title="Title" placement="right">
    <div slot="content">
        Popover on right
    </div>
    <n3-button>Popover on right</n3-button>
  </n3-popover>
  <n3-popover effect="fade" :header="false" placement="bottom" title="Title">
    <div slot="content">
        Popover on bottom
      </div>
    <n3-button>Popover on bottom</n3-button>
  </n3-popover>
  <hr>
  <h4>Triger</h4>
    <n3-popover effect="scale" title="Title" placement="top" trigger="hover">
        <div slot="content">
          Mouseenter
        </div>
        <n3-button>Mouseenter</n3-button>
    </n3-popover>
    <hr>
  <h4>Focus</h4>
  <n3-popover effect="scale" title="Title" placement="bottom" trigger="focus">
    <div slot="content">
        Focus
    </div>
    <n3-input placeholder="Focus"></n3-input>
  </n3-popover>
  <h4>confirm</h4>
  <n3-pop-confirm content="delete it？" :on-confirm="del(item)">
      <n3-button>delete</n3-button>
  </n3-pop-confirm>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">:header</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span>  <span class="hljs-attr">placement</span>=<span class="hljs-string">"top"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span> &gt;</span>
        Popover on top
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on top<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">:header</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span>  <span class="hljs-attr">placement</span>=<span class="hljs-string">"left"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
        Popover on left
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on left<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">:header</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span>  <span class="hljs-attr">placement</span>=<span class="hljs-string">"right"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
        Popover on right
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on right<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"bottom"</span> <span class="hljs-attr">:header</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> &gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span> &gt;</span>
        Popover on bottom
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on bottom<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">hr</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">h4</span>&gt;</span>No title<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span>   <span class="hljs-attr">:header</span> =<span class="hljs-string">"false"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span>  <span class="hljs-attr">placement</span>=<span class="hljs-string">"top"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
        Popover on top
      <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on top<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span>  <span class="hljs-attr">:header</span> =<span class="hljs-string">"false"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span>  <span class="hljs-attr">placement</span>=<span class="hljs-string">"left"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
        Popover on left
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on left<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span>  <span class="hljs-attr">:header</span> =<span class="hljs-string">"false"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span>  <span class="hljs-attr">placement</span>=<span class="hljs-string">"right"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
        Popover on right
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on right<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">:header</span> =<span class="hljs-string">"false"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"bottom"</span>  <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> &gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
        Popover on bottom
      <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on bottom<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">hr</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">h4</span>&gt;</span>Triger<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"scale"</span>  <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span>  <span class="hljs-attr">placement</span>=<span class="hljs-string">"top"</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"hover"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
          Mouseenter
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Mouseenter<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">hr</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">h4</span>&gt;</span>Focus<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"scale"</span>
  <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span>  <span class="hljs-attr">placement</span>=<span class="hljs-string">"bottom"</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"focus"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
        Focus
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">n3-input</span> <span class="hljs-attr">placeholder</span>=<span class="hljs-string">"Focus"</span> &gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-input</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">h4</span>&gt;</span>confirm<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-pop-confirm</span>
      <span class="hljs-attr">content</span>=<span class="hljs-string">"delete it？"</span>
      <span class="hljs-attr">:on-confirm</span>=<span class="hljs-string">"del(item)"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> &gt;</span>delete<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-pop-confirm</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript">del(item){
  <span class="hljs-keyword">return</span> <span class="hljs-keyword">new</span> <span class="hljs-built_in">Promise</span>(<span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">resolve, reject</span>) </span>{
    setTimeout(<span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params"></span>) </span>{
      alert(<span class="hljs-string">'delete'</span> +  item)
      resolve()
    },<span class="hljs-number">500</span>);
  });
}
</code></pre>
<h3>popover Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>trigger</td>
<td><code v-pre="">String</code>, one of <code v-pre="">click</code> <code v-pre="">focus</code> <code v-pre="">hover</code></td>
<td><code v-pre="">click</code></td>
<td>trigger type</td>
</tr>
<tr>
<td>effect</td>
<td><code v-pre="">String</code>, one of <code v-pre="">scale</code> <code v-pre="">fade</code></td>
<td><code v-pre="">scale</code></td>
<td></td>
</tr>
<tr>
<td>title</td>
<td><code v-pre="">String</code></td>
<td></td>
<td></td>
</tr>
<tr>
<td>header</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>whether header is visible or not</td>
</tr>
<tr>
<td>placement</td>
<td><code v-pre="">String</code>, one of  <code v-pre="">top</code> <code v-pre="">left</code> <code v-pre="">right</code> <code v-pre="">bottom</code></td>
<td></td>
<td>placement</td>
</tr>
</tbody>
</table>
<h3>popconfirm Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>effect</td>
<td><code v-pre="">String</code>, one of  <code v-pre="">scale</code> <code v-pre="">fade</code></td>
<td><code v-pre="">fade</code></td>
<td></td>
</tr>
<tr>
<td>content</td>
<td><code v-pre="">String</code></td>
<td></td>
<td></td>
</tr>
<tr>
<td>placement</td>
<td><code v-pre="">String</code>, one of  <code v-pre="">top</code> <code v-pre="">left</code> <code v-pre="">right</code> <code v-pre="">bottom</code></td>
<td></td>
<td>placement</td>
</tr>
<tr>
<td>on-confirm</td>
<td><code v-pre="">Function</code></td>
<td></td>
<td>confirm function</td>
</tr>
<tr>
<td>ok-text</td>
<td><code v-pre="">String</code></td>
<td>ok</td>
<td>text of confirm button</td>
</tr>
<tr>
<td>cancel-text</td>
<td><code v-pre="">String</code></td>
<td>cancel</td>
<td>text of cancel button</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      title: 'Title',
      text: 'Lorem ipsum dolor sit amet',
      item: '1'
    }
  },
  methods: {
    del(item){
      return function() {
        return new Promise(function(resolve, reject) {
          setTimeout(function() {
            alert('delete' + item)
            resolve()
          },500);
        });
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3PopoverDocs.md?1463d066